<template>
  <mf-loading-dialog :loading="$apollo.queries.units.loading">
    <base-page-layout title="Gerenciamento de preço">
      <v-container fluid class="pb-0">
        <v-row>
          <v-spacer />
          <mf-button label="Importar novo arquivo" class="mb-2" text @click="dialogImportarArquivo = true" />
        </v-row>
      </v-container>
      <v-card>
        <v-card-text>
          <v-data-table :headers="headers" :items="units" disable-pagination hide-default-footer>
            <template v-slot:item="{ item }">
              <tr v-if="item.ecommerce.products_file">
                <td>{{ item.name }}</td>
                <td>
                  <a class="link" :href="item.ecommerce.products_file.url">
                    {{ item.ecommerce.products_file.filename }}
                  </a>
                </td>
                <td>{{ item.ecommerce.products_file.nof_products | localeString }}</td>
                <td>
                  <span>
                    {{ DateTime.fromFormat(item.ecommerce.products_file.updated_at.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }}
                  </span>
                </td>
              </tr>
              <tr v-else>
                <td>{{ item.name }}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <importar-arquivo v-model="dialogImportarArquivo" :units="units" @finished="openUploadStatusDialog" />
      <upload-status-dialog v-model="dialogUploadStatus" :status="uploadStatus" />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import { sanitizeUnits } from '@/helpers/units'

const QUERY_UNITS = gql`
  query Units {
    units: allUnits {
      _id
      id_erp
      name
      ecommerce {
        products_file {
          url
          updated_at
          filename
          nof_products
        }
      }
    }
  }
`

export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    ImportarArquivo: () => import('@/modules/pedidos/gerenciamento-preco/views/pages/ImportarArquivo.vue'),
    UploadStatusDialog: () => import('@/modules/pedidos/gerenciamento-preco/views/pages/UploadStatusDialog.vue'),
  },
  data: () => ({
    units: [],
    dialogImportarArquivo: false,
    dialogUploadStatus: false,
    uploadStatus: {},
    DateTime: DateTime,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Unidade',
          value: 'name',
          width: '25%',
        },
        {
          text: 'Último .csv importado',
          value: 'ecommerce.products_file.filename',
          width: '25%',
        },
        {
          text: 'Quantidade de itens',
          value: 'ecommerce.products_file.nof_products',
          width: '25%',
        },
        {
          text: 'Data da última importação',
          value: 'ecommerce.products_file.updated_at',
          width: '25%',
        },
      ]
    },
  },
  apollo: {
    units: {
      query: QUERY_UNITS,
      update({ units }) {
        return sanitizeUnits(units)
      },
    },
  },
  methods: {
    openUploadStatusDialog(status) {
      this.uploadStatus = status
      this.dialogUploadStatus = true
      this.$apollo.queries.units.refetch()
    },
  },
}
</script>

<style></style>
